import { upperFirst } from 'Utils/common';

export default {
  notificationSystemData: state => state.notificationSystemData,
  notificationUpdatesData: state => state.notificationUpdatesData,
  notificationsAllData: (state, getters) => {
    const items = getters.notificationSystemData.concat(getters.notificationUpdatesData);
    items.sort((a, b) => new Date(b.time) - new Date(a.time));
    return items;
  },
  notificationSystemLoading: state => state.notificationSystemLoading,
  notificationUpdatesLoading: state => state.notificationUpdatesLoading,
  notificationsAllLoading: (state, getters) => (
    getters.notificationSystemLoading || getters.notificationUpdatesLoading
  ),
  notificationSystemCount: state => state.notificationSystemCount,
  notificationUpdatesCount: state => state.notificationUpdatesCount,
  notificationsCountsLoading: state => state.notificationsCountsLoading,
  notificationsAllCount: (state, getters) => (
    getters.notificationSystemCount + getters.notificationUpdatesCount
  ),
  // TODO: rename to notificationsSystemCountNew
  notificationSystemNew: state => state.notificationSystemNew,
  // TODO: rename to notificationsUpdateCountNew
  notificationUpdatesNew: state => state.notificationUpdatesNew,
  // TODO: rename to notificationsAllCountNew
  notificationsAllNew: (state, getters) => (
    getters.notificationSystemNew + getters.notificationUpdatesNew
  ),
  notificationSystemLastId: (state, getters) => {
    if (!getters.notificationSystemData.length) return null;
    return getters.notificationSystemData[getters.notificationSystemData.length - 1].id;
  },
  notificationUpdatesLastId: (state, getters) => {
    if (!getters.notificationUpdatesData.length) return null;
    return getters.notificationUpdatesData[getters.notificationUpdatesData.length - 1].id;
  },
  isNotificationSystemLoadedAll: (state, getters) => (
    getters.notificationSystemData.length >= getters.notificationSystemCount
  ),
  isNotificationUpdatesLoadedAll: (state, getters) => (
    getters.notificationUpdatesData.length >= getters.notificationUpdatesCount
  ),
  getNotificationsDataByType: (state, getters) => (type, channel) => {
    const capType = upperFirst(type);
    if (!channel) return getters[`notificationsAll${capType}`];
    const capChannel = upperFirst(channel);
    return getters[`notification${capChannel}${capType}`];
  },
  getNotificationsData: (state, getters) => channel => (
    getters.getNotificationsDataByType('data', channel)
  ),
  getNotificationsLoading: (state, getters) => channel => (
    getters.getNotificationsDataByType('loading', channel)
  ),
  getNotificationsCount: (state, getters) => channel => (
    getters.getNotificationsDataByType('count', channel)
  ),
  getNotificationsCountNew: (state, getters) => channel => (
    getters.getNotificationsDataByType('new', channel)
  ),
  getIsNotificationsLoadedAll: (state, getters) => (channel) => {
    if (channel === 'updates') return getters.isNotificationUpdatesLoadedAll;
    if (channel === 'system') return getters.isNotificationSystemLoadedAll;
    return true;
  },
  isSomeNotificationsWithRedFlag: (state, getters) => (
    getters.notificationsAllData
      .some(item => (item.message.flag === 'red' && item.read_flag === false))
  ),
};
